// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"__175w-rigid-solar-panel_productcontent__8aeQe"};